import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import useRedirectEstablishmentActiveContent from '../../../../Components/Hooks/useRedirectEstablishmentActiveContent';
import Search404 from '../../../AuthenticationInner/Errors/Search';
import ItemList from './ItemList';

const ItemsList = () => {
    const { id } = useParams();	
    const redirectEstablishmentActiveContent = useRedirectEstablishmentActiveContent('/warehouse/establishmentId/ppe/items');

    const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Bodega', icon: 'icon-warehouse' },
	];

    if (id === 'all')
        return (
                <React.Fragment>
                        <UiContent />
                        <div className="page-content mb-10" style={{ paddingBottom: '90px' }}>
                                <Container fluid>
                                        <BreadCrumb title={`Lista de items `} hidden={true} icon={'icon-layout-dashboard'} />
                                        <Search404 />
                                </Container>
                        </div>
                </React.Fragment>
        )

    return (
        <React.Fragment>
            <UiContent />
            <div className='page-content'>
                <Container fluid>
                    <BreadCrumb title='Lista de items' links={breadcrumbLinks} icon={'icon-layout-dashboard'} />
                    <ItemList establishment_id={id} />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ItemsList;